import BaseDialog from '@material-ui/core/Dialog'

const Dialog = BaseDialog

export default Dialog
